import { render } from "./resource-search.vue?vue&type=template&id=002eef8e&scoped=true"
import script from "./resource-search.vue?vue&type=script&lang=js"
export * from "./resource-search.vue?vue&type=script&lang=js"

import "./resource-search.vue?vue&type=style&index=0&id=002eef8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002eef8e"]])

export default __exports__